 
import React, {useContext} from 'react';
import {BridleContext} from '../BridleContextProvider';
import {getAttributesGroupedInDisplayOrder, getSortOrder, orderMap} from '../HelperFunctions';
import Toolbar from '../components/Toolbar';
import SectionInfo from '../components/SectionInfo';
import Buttons from '../components/Buttons';
import Page from '../components/Page';

const Browband = () => {
    const {products, options} = useContext(BridleContext);
    const pieces = getSortOrder(products, orderMap.Browband);
    const productId = options.Browband.productId;
    const attributesInOrder = getAttributesGroupedInDisplayOrder(pieces.attributeValues);

    return (
        <div className="bridle-page-content">
            <Toolbar pageName="Browband" />
            <SectionInfo section="Browband" page="3" />
            <Page
                attributes={attributesInOrder}
                pageName="Browband"
                pieces={pieces}
                productId={productId}
                sizeGuide="browband"
            />
            <Buttons back="/crown" next="/cheekpiece" disableButton={productId === ''} />
        </div>
    );
};

export default Browband;
